import React from 'react';
import styled from '@emotion/styled';
import { media, mediaQueries } from '../../../style/global-style';
import GiftSVG from '../../../../public/static/icons/gift.svg';
import ArrowSVG from '../../../../public/static/arrow.svg';
import ExpertSVG from '../../../../public/static/icons/expert.svg';
import CheckMarkSVG from '../../../../public/static/icons/checkMark.svg';
import BestpriceSVG from '../../../../public/static/icons/bestprice.svg';
import { StyledListItem, StyledWrapper } from '../../atoms/icon-list/icon-list.style';

interface IArrowIcon {
    isCollapsed: boolean;
}

export const StyledComponentWrapper = styled.section`
    color: ${(props) => props.theme.colors.black};
    margin: 0 auto;
    max-width: 100%;

    @media ${mediaQueries.tablet} {
        margin: 0 auto;
        max-width: calc(100% - 30px);
    }

    @media ${mediaQueries.smallDesktopAndUp} {
        max-width: calc(100% - 30px);
        padding-top: 60px;
        padding-bottom: 30px;
    }
    @media ${mediaQueries.desktopAndUp} {
        max-width: 1170px;
    }
`;

export const StyledExclusivesOuterWrapper = styled.div`
    background-color: ${(props) => props.theme.shades.white};

    ${media.tablet`
        background-color: transparent;
    `}
`;

export const StyledHighlightInnerWrapper = styled.div`
    width: 100%;
    margin: 0 auto;
    ${media.tablet`
        margin: 0 auto;
        width: 100%;
    `}
`;

export const StyledExclusivesInnerWrapper = styled.div`
    background-color: rgba(0, 98, 149, 0.1);
    width: 100%;
    margin: 0 auto;
    padding: 12px 20%;

    ${StyledListItem} {
        span {
            font-size: 14px;
        }
    }

    ${StyledWrapper} {
        padding-top: 10px;
    }

    ${media.tablet`
        padding: 12px;
    `}

    @media ${mediaQueries.smallDesktopAndUp} {
        padding: 12px 25px;

        ${StyledListItem} {
            span {
                font-size: 15px;
            }
        }
    }
`;

export const StyledShowMoreBtn = styled.button`
    background-color: ${(props) => props.theme.shades.white};
    color: ${(props) => props.theme.colors.main4};
    font-size: ${(props) => props.theme.fontSize.copyTextM};
    font-weight: 700;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    padding: 15px 0 15px 0;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    width: 100%;

    ${media.smallDesktop`
        display: none;
    `};
`;

export const StyledArrowIcon = styled(({ isCollapsed, ...rest }: IArrowIcon) => (
    <ArrowSVG {...rest} />
))`
    width: 12px;
    height: 12px;
    margin-left: 5px;
    stroke-width: 2;
    fill: ${(props) => props.theme.colors.main4};
    transform: ${(props) => (props.isCollapsed ? `rotate(90deg)` : `rotate(-90deg)`)};
`;

export const StyledLabelledArrowWrapper = styled.div`
    position: relative;
    top: 0;
    padding: 5px 0;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${(props) => props.theme.shades.white};
    background-color: ${(props) => props.theme.labels.onlineBookable};
    font-weight: 500;
    font-size: ${(props) => props.theme.fontSize.copyTextL};
`;

export const StyledArrowText = styled.span`
    padding: 0 9px;
`;

export const GiftIcon = styled(GiftSVG)`
    fill: ${(props) => props.theme.labels.onlineBookable};
    height: inherit;
    width: inherit;
`;

export const CheckMarkIcon = styled(CheckMarkSVG)`
    fill: ${(props) => props.theme.labels.onlineBookable};
    height: 20px;
    width: 20px;
`;

export const ExpertIcon = styled(ExpertSVG)`
    fill: ${(props) => props.theme.labels.onlineBookable};
    height: inherit;
    width: inherit;
`;

export const BestpriceIcon = styled(BestpriceSVG)`
    fill: ${(props) => props.theme.labels.onlineBookable};
    height: inherit;
    width: inherit;
`;
